import React, { useState, useEffect } from "react";
import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../Redux/axios/AxiosInstance";
import {
  quick_quotes_Bike,
  QuickQuote_Post,
  quick_quoteValues,
  Err_quotes,
} from "../../Redux/actions/NumBikeation";
import { insuranceproduct } from "../../Redux/actions/NumBikeation";
import { Button, Form, Radio, message } from "antd/lib";
import moment from "moment";
export default function Prevpolictype({ setIsModalOpen }) {
  const dispatch = useDispatch();
  const vechicleData = useSelector((state) => state.vehicledetail.vahanData);
  const QuickQuotes = useSelector(
    (state) => state.vehicledetail.quickquotes.data
  );
  console.log("QuickQuotes", QuickQuotes);
  const QuickQuotePost = useSelector(
    (state) => state?.vehicledetail?.quickQuotePost
  );
  const QuoteInput = useSelector((state) => state?.vehicledetail?.quoteInput);
  const auth = useSelector((state) => state.vehicledetail.bikenum);
  // const [QuotePost, setQuotePost] = useState(QuickQuotePost)
  const [loading, setLoading] = useState(false);
  const [product, setproduct] = useState([]);

  useEffect(() => {
    dispatch(insuranceproduct())
      .then((res) => {
        setproduct(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [dispatch]);
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    // setValue(e.target.value);
  };
  const onFinish = (values) => {
    console.log("product values", values);
    const productcode = values.product;

    const registrationDate = moment(QuickQuotePost.registrationDate).format(
      "YYYY-MM-DD"
    );
    const regDate = new Date(registrationDate);
    regDate.setFullYear(regDate.getFullYear() + 5);

    const updateQuoteInput = {
      ...QuoteInput,
      insuranceProductCode: productcode,
      productCode:
        productcode === "Not_Secure"
          ? "TWT"
          : productcode === "Bundled"
          ? "TWS"
          : productcode,
      ncbvalue:
        productcode === "Not_Secure" || productcode === "TWT"
          ? ""
          : QuoteInput?.ncbvalue,
    };

    let currentTP = {
      currentThirdPartyPolicyNumber:
        productcode === "TWS" || productcode === "Bundled"
          ? vechicleData?.insurance_policy_number
          : null,
      currentThirdPartyPolicyInsurerCode:
        productcode === "TWS" || productcode === "Bundled" ? "115" : null,
      currentThirdPartyPolicyStartDateTime:
        productcode === "TWS" || productcode === "Bundled"
          ? moment(QuickQuotePost.registrationDate).format("YYYY-MM-DD")
          : null,
      currentThirdPartyPolicyExpiryDateTime:
        productcode === "TWS" || productcode === "Bundled"
          ? moment(regDate).format("YYYY-MM-DD")
          : null,
    };
    const updatedQuotePost = {
      ...QuickQuotePost,
      previousPolicyExpiryDate:
        productcode === "Not_Secure"
          ? moment(new Date()).format("YYYY-MM-DD")
          : QuickQuotePost?.previousPolicyExpiryDate,
      product_code:
        productcode === "Not_Secure"
          ? "TWT"
          : productcode === "Bundled"
          ? "TWS"
          : productcode,
      currentThirdPartyPolicy:
        productcode === "TWS" || productcode === "Bundled" ? currentTP : null,
      originalPreviousPolicyType:
        productcode === "TWS"
          ? "1OD_0TP"
          : productcode === "Bundled"
          ? "1OD_5TP"
          : null,
      previousInsurerCode: productcode === "Not_Secure" ? null : "115",
      isPreviousInsurerKnown: productcode === "Not_Secure" ? 0 : 1, //0 r 1 int
    };
    console.log(updatedQuotePost);
    setLoading(true);
    axiosInstance
      .post(
        `v2/bike_insurances/${auth.bike_insurance_id}/quick_quotes`,
        updatedQuotePost
      )
      .then((res) => {
        if (res.status === 200) {
          const Udata = res?.data?.data;
          //console.log("data-----------------",data)
          const errData = Udata?.filter(
            (item) => "status" in item && item.status === "failed"
          );
          dispatch(Err_quotes(errData));
          const filteredData = Udata?.filter(
            (item) => "status" in item && item.status === "success"
          );
          const updatedData = filteredData?.map((item) => ({
            ...item,
            IsGst: true,
          }));
          dispatch(quick_quotes_Bike(updatedData));
          // if (!res.data.error) {
          // let data = {
          //   data: res.data.data,
          // };
          //console.log(data)
          //dispatch(quick_quotes_Bike(data));
          dispatch(QuickQuote_Post(updatedQuotePost));
          dispatch(quick_quoteValues(updateQuoteInput));
          setLoading(false);
          setIsModalOpen(false);
          // } else {
          // message.error(res.data.error.validationMessages.join(","));
          // }
        }
      })
      .catch((err) => {
        console.log(err.response.data.error);
        setLoading(false);
        message.error(err.response.data.error);
      });
  };
  return (
    <>
      <Form onFinish={onFinish} layout="vertical" requiredMark={false}>
        <Form.Item
          name="product"
          label="It will help us to provide accurate quotes for you"
          rules={[
            {
              required: true,
              message: "Please select Policy Type",
            },
          ]}
          initialValue={QuoteInput?.insuranceProductCode}
        >
          <Radio.Group
            className="py-3 px-3 pb-0 bg-white ant-radio-layout prev-prod-sec"
            onChange={onChange}
          >
            {/* {product.map((e) => (
                  <Radio
                  key={e.id} value={e.product_code}>
                    {e.product_name}
                  </Radio>
                ))} */}
            <Radio value="TWP">2W Comprehensive</Radio>
            <Radio value="TWT">2W TP only</Radio>
            <Radio value="TWS">2W SAOD</Radio>
            <Radio value="Bundled">Bundled 1+5 Policy</Radio>
            <Radio value="Not_Secure">Not Secure</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            htmlType="submit"
            className="update-qut-button"
            loading={loading}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
